export default {
  getUser: state => state.quotation.user,
  getGender: state => state.quotation.user.personalData.gender,
  getSelectedValue: state => state.quotation.user.financialData.selectedInsurer.value,
  getInsurers: state => state.simulation.insurers,
  getInsurer: state => id => {
    return state.simulation.insurers.list.find(insurer => insurer.id === id);
  }
};
